import API from './api';

export default class MktSiteApi {
  static getCode(id, params) {
    return API.get(`/mkt_sites/${id}/get_code`, params);
  }
}
